import React from 'react';

const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg" width="490" height="490" viewBox="0 0 24 24">
    <path d="M17.91 9.412L4.937.676C3.852-.046 2.76-.204 1.841.272 1.004.676.5 1.636.5 2.84v18.354c0 1.204.504 2.164 1.34 2.568.333.159.671.238 1.086.238.587 0 1.34-.238 2.011-.562L17.91 14.7c1.003-.642 1.59-1.602 1.59-2.647 0-1.046-.587-2.006-1.59-2.642zm-1.008 3.925L3.928 22.074c-.504.404-1.002.483-1.34.318-.332-.159-.505-.642-.505-1.204V2.834c0-.642.166-1.04.505-1.204.083-.08.249-.08.332-.08.249 0 .67.08 1.085.404l12.973 8.736c.504.318.836.801.836 1.284.013.483-.325.96-.912 1.363z" transform="translate(-1182 -938) translate(135 365) translate(20 377) translate(10 177) translate(1017 19) translate(2)"/>
  </svg>

);

export default PlayIcon;
